var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcessorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58987 14.6135C4.58987 14.8068 4.42079 14.9758 4.22755 14.9758C4.03432 14.9758 3.86523 14.8068 3.86523 14.6135V0.362319C3.86523 0.169082 4.03432 0 4.22755 0C4.42079 0 4.58987 0.169082 4.58987 0.362319V14.6135Z",
    fill: "#EAC113"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17871 0C4.3961 0 4.58934 0.169082 4.58934 0.386473V14.6135C4.58934 14.8309 4.3961 15 4.20287 15",
    fill: "#E8A615"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2803 14.6135C6.2803 14.8068 6.11122 14.9758 5.91798 14.9758C5.72475 14.9758 5.55566 14.8068 5.55566 14.6135V0.362319C5.55566 0.169082 5.72475 0 5.91798 0C6.11122 0 6.2803 0.169082 6.2803 0.362319V14.6135Z",
    fill: "#EAC113"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86914 0C6.06238 0 6.27977 0.169082 6.27977 0.386473V14.6135C6.27977 14.8309 6.08653 15 5.86914 15",
    fill: "#E8A615"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42093 14.6135C9.42093 14.8068 9.25184 14.9758 9.05861 14.9758C8.86537 14.9758 8.69629 14.8068 8.69629 14.6135V0.362319C8.69629 0.169082 8.86537 0 9.05861 0C9.25184 0 9.42093 0.169082 9.42093 0.362319V14.6135Z",
    fill: "#EAC113"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10593 0C9.29916 0 9.41994 0.169082 9.41994 0.386473V14.6135C9.41994 14.8309 9.27501 15 9.05762 15",
    fill: "#E8A615"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1114 14.6135C11.1114 14.8068 10.9423 14.9758 10.749 14.9758C10.5558 14.9758 10.3867 14.8068 10.3867 14.6135V0.362319C10.3867 0.169082 10.5558 0 10.749 0C10.9423 0 11.1114 0.169082 11.1114 0.362319V14.6135Z",
    fill: "#EAC113"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7732 0C10.9906 0 11.1113 0.169082 11.1113 0.386473V14.6135C11.1113 14.8309 10.9664 15 10.749 15",
    fill: "#E8A615"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85061 14.6135C7.85061 14.8068 7.68153 14.9758 7.4883 14.9758C7.29506 14.9758 7.12598 14.8068 7.12598 14.6135V0.362319C7.12598 0.169082 7.29506 0 7.4883 0C7.68153 0 7.85061 0.169082 7.85061 0.362319V14.6135Z",
    fill: "#EAC113"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51244 0C7.72983 0 7.8506 0.169082 7.8506 0.386473V14.6135C7.8506 14.8309 7.70567 15 7.48828 15",
    fill: "#E8A615"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.386473 4.59183C0.169082 4.59183 0 4.4469 0 4.22951C0 4.01212 0.169082 3.86719 0.386473 3.86719H14.6135C14.8309 3.86719 15 4.01212 15 4.22951C15 4.4469 14.8309 4.59183 14.6135 4.59183H0.386473Z",
    fill: "#EAC113"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9758 4.17969C14.9758 4.39708 14.8068 4.59032 14.5894 4.59032H0.386473C0.169082 4.59032 0 4.39708 0 4.20384",
    fill: "#E8A615"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9758 5.91701C14.9758 6.11024 14.8068 6.27933 14.6135 6.27933H0.362319C0.169082 6.27933 0 6.11024 0 5.91701C0 5.72377 0.169082 5.55469 0.362319 5.55469H14.6135C14.8068 5.55469 14.9758 5.72377 14.9758 5.91701Z",
    fill: "#EAC113"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9758 5.86719C14.9758 6.08458 14.8068 6.27782 14.5894 6.27782H0.386473C0.169082 6.27782 0 6.08458 0 5.86719",
    fill: "#E8A615"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9758 9.05763C14.9758 9.25087 14.8068 9.41995 14.6135 9.41995H0.362319C0.169082 9.41995 0 9.25087 0 9.05763C0 8.86439 0.169082 8.69531 0.362319 8.69531H14.6135C14.8068 8.69531 14.9758 8.86439 14.9758 9.05763Z",
    fill: "#EAC113"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9758 9.11081C14.9758 9.3282 14.8068 9.42482 14.5894 9.42482H0.386473C0.169082 9.42482 0 9.27989 0 9.0625",
    fill: "#E8A615"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9758 7.60451C14.9758 7.79774 14.8068 7.96683 14.6135 7.96683H0.362319C0.169082 7.96683 0 7.79774 0 7.60451C0 7.41127 0.169082 7.24219 0.362319 7.24219H14.6135C14.8068 7.24219 14.9758 7.41127 14.9758 7.60451Z",
    fill: "#EAC113"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9758 7.65768C14.9758 7.87508 14.8068 7.97169 14.5894 7.97169H0.386473C0.169082 7.97169 0 7.82677 0 7.60938",
    fill: "#E8A615"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0.386473 11.1075C0.169082 11.1075 0 10.9625 0 10.7451C0 10.5277 0.169082 10.3828 0.386473 10.3828H14.6135C14.8309 10.3828 15 10.5277 15 10.7451C15 10.9625 14.8309 11.1075 14.6135 11.1075H0.386473Z",
    fill: "#EAC113"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9758 10.7742C14.9758 10.9915 14.8068 11.1123 14.5894 11.1123H0.386473C0.169082 11.1123 0 10.9674 0 10.75",
    fill: "#E8A615"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3187 11.5216C12.3187 11.9564 11.9564 12.3187 11.5216 12.3187H3.69554C3.26076 12.3187 2.89844 11.9564 2.89844 11.5216V3.69554C2.89844 3.26076 3.26076 2.89844 3.69554 2.89844H11.5216C11.9564 2.89844 12.3187 3.26076 12.3187 3.69554V11.5216Z",
    fill: "#363F3E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89844 3.69554C2.89844 3.26076 3.26076 2.89844 3.69554 2.89844H11.5216C11.9564 2.89844 12.3187 3.26076 12.3187 3.69554V11.5216C12.3187 11.9564 11.9564 12.3187 11.5216 12.3187",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6285 10.1252C10.6285 10.415 10.4111 10.6324 10.1212 10.6324H5.09709C4.80724 10.6324 4.58984 10.415 4.58984 10.1252V5.101C4.58984 4.81114 4.80724 4.59375 5.09709 4.59375H10.1212C10.4111 4.59375 10.6285 4.81114 10.6285 5.101V10.1252Z",
    fill: "#495150"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58984 5.101C4.58984 4.81114 4.80724 4.59375 5.09709 4.59375H10.1212C10.4111 4.59375 10.6285 4.81114 10.6285 5.101V10.1252C10.6285 10.415 10.4111 10.6324 10.1212 10.6324",
    fill: "#393F3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessorIcon);
export default __webpack_public_path__ + "static/media/processorIcon.2e3cc158374d00e7cf0904df54ee05db.svg";
export { ForwardRef as ReactComponent };